import { render, staticRenderFns } from "./FitmentCTA.vue?vue&type=template&id=fbf693a2&scoped=true"
import script from "./FitmentCTA.vue?vue&type=script&lang=ts"
export * from "./FitmentCTA.vue?vue&type=script&lang=ts"
import style0 from "./FitmentCTA.vue?vue&type=style&index=0&id=fbf693a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf693a2",
  null
  
)

export default component.exports